import axios from "axios";
import { API_HOST } from "../../api_utils";

export const addUserByCompanyAdmin = async (userData, token) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.post(
    `${API_HOST}company-admin/create-user`,
    userData,
    config
  );
  return response.data;
};

export const transferProject = async (payload, token) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.post(
    `${API_HOST}projects/ownership/transfer`,
    payload,
    config
  );
  return response.data;
};

export const generateDocker = async (payload, token) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.post(
    `${API_HOST}GenerateBuild/http/build`,
    payload,
    config
  );
  return response.data;
};

export const getOrgEmployees = async (orgId, token, query) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  let url = `${API_HOST}organisation/get-employees/${orgId}`;

  if (query) {
    url += `?${query}`;
  }

  const response = await axios.get(url, config);
  return response.data.employees;
};

export const getOrgPartners = async (orgId, token) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(
    `${API_HOST}organisation/${orgId}/partners`,
    config
  );
  return response.data;
};
export const getDeletedPages = async (token) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(`${API_HOST}pages/deleted`, config);
  return response.data;
};

export const getBaseUrlConfig = async (projectId, token) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(
    `${API_HOST}projects/save-config/${projectId}`,
    config
  );
  return response.data;
};

export const getDockerImages = async (orgId, token) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(`${API_HOST}docker/org/${orgId}`, config);
  return response.data;
};

export const deleteDockerImages = async (id, token) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.delete(`${API_HOST}docker/${id}`, config);
  return response.data;
};

export const deletedPageRestore = async (pageId, token) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.patch(
    `${API_HOST}pages/${pageId}/restore`,
    {},
    config
  );
  return response.data;
};

export const getTransferRequestsOfUser = async (token) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(
    `${API_HOST}projects/ownership/transfer/requests`,
    config
  );
  return response.data;
};

export const getProfileStats = async (token) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(`${API_HOST}user/stats`, config);
  return response.data;
};

export const AcceptDeclineTransfer = async (payload, token) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.post(
    `${API_HOST}projects/ownership/transfer/requests`,
    payload,
    config
  );
  return response.data;
};

export const getLogsByOrg = async (orgId, token, filters = {}) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const { project, user, startDate, endDate, onlyProjectLogs, onlyUserLogs,page,limit } =
    filters;
  const queryParams = new URLSearchParams();
  if (project && project !== "all") queryParams.append("project", project);
  if (user && user !== "all") queryParams.append("user", user);
  if (startDate) queryParams.append("startDate", startDate);
  if (endDate) queryParams.append("endDate", endDate);
  if (onlyProjectLogs) queryParams.append("onlyProjectLogs", "true");
  if (onlyUserLogs) queryParams.append("onlyUserLogs", "true");
  if (page) queryParams.append("page", page);
  if (limit) queryParams.append("limit", limit);

  const url = `${API_HOST}user_logs/org/${orgId}?${queryParams.toString()}`;

  const response = await axios.get(url, config);
  return response.data;
};
